import { DataGrid, GridColDef, GridSortModel } from '@mui/x-data-grid';
import {
  collection,
  query,
  orderBy,
  startAfter,
  limit,
  getDocs,
  getCountFromServer,
} from 'firebase/firestore';
import { db } from '../../firebase';
import { Timestamp } from 'firebase/firestore';
//import { useResolvedReference } from '../hooks/useResolvedReference';
import { useRecordContext } from 'react-admin';
import { useEffect, useState } from 'react';


const columns: GridColDef[] = [
  { field: 'tokens_earned', headerName: 'Tokens Earned', width: 130 },
  {
    field: 'date_earned',
    headerName: 'Date Earned',
    width: 200,
    renderCell: (params) => {
      const v = params.value;
      if (!v) return '';
      // If it's a Firestore Timestamp, convert to Date
      if ((v as any).toDate instanceof Function) {
        return (v as Timestamp).toDate().toLocaleString();
      }
      // Otherwise assume it's already a date string or number
      return new Date(v as string | number).toLocaleString();
    },
  },
  { field: 'ad_source', headerName: 'Ad Source', width: 150 },
  { field: 'ad_value_usd', headerName: 'Ad Value (USD)', width: 150 },
  {
    field: 'redeemed',
    headerName: 'Redeemed',
    width: 100,
    renderCell: (params) => (params.value ? 'Yes' : 'No'),
  },
  {
    field: 'id',
    headerName: 'Reference',
    width: 200,
    renderCell: (params) => {
      return params.row?.id || '';
    },
  },
];

export const AdRewards = () => {
  const record = useRecordContext();
  const userId = record?.id?.toString();
  const [rows, setRows] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [rowCount, setRowCount] = useState(0);
  const [lastVisible, setLastVisible] = useState<any>(null);
  const [sortModel, setSortModel] = useState<GridSortModel>([
    { field: 'date_earned', sort: 'desc' },
  ]);

useEffect(() => {
  setLastVisible(null);
  setPage(0);
}, [sortModel, lastVisible]);

  useEffect(() => {
    if (!userId) return;
    const fetchPage = async () => {
      setLoading(true);
      // Count total
      try {
        const countSnap = await getCountFromServer(
          query(collection(db, 'users', userId, 'ad_rewards'))
        );
        setRowCount(countSnap.data().count);
      } catch { /* ignore count errors */ }

      // Build base collection reference
      const baseCollection = collection(db, 'users', userId, 'ad_rewards');

      const activeSort = sortModel[0] || { field: 'date_earned', sort: 'desc' };
      const sortField = activeSort.field;
      const sortDirection = activeSort.sort ?? 'desc';
      // Normalize to Firestore's order direction
      const direction = sortDirection.toLowerCase() as 'asc' | 'desc';

      let qRef;
      if (page > 0 && lastVisible) {
        qRef = query(
          baseCollection,
          orderBy(sortField, direction),
          startAfter(lastVisible),
          limit(pageSize)
        );
      } else {
        qRef = query(
          baseCollection,
          orderBy(sortField, direction),
          limit(pageSize)
        );
      }

      const snap = await getDocs(qRef);
      console.log('AdRewards fetchPage: querying ad_rewards for user', userId, 'with page', page, 'pageSize', pageSize, 'sortModel', sortModel);
      console.log('Firestore query returned', snap.docs.length, 'documents');
      console.log('Document IDs:', snap.docs.map(d => d.id));
      const docs = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      setRows(docs);
      setLastVisible(snap.docs[snap.docs.length - 1] || null);
      setLoading(false);
    };
    fetchPage();
  }, [userId, page, pageSize, sortModel, lastVisible]);

  console.log('AdRewards rows length:', rows.length);

  if (loading && rows.length === 0) return <p>Loading...</p>;

  console.log('AdRewards rows:', rows);

  return (
    <div style={{ height: 600, width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        pagination
        paginationMode="server"
        page={page}
        pageSize={pageSize}
        onPageChange={(newPage) => setPage(newPage)}
        onPageSizeChange={(newSize) => setPageSize(newSize)}
        rowCount={rowCount}
        sortingMode="server"
        sortModel={sortModel}
        onSortModelChange={(model) => setSortModel(model)}
        loading={loading}
      />
    </div>
  );
};